import { render, staticRenderFns } from "./FullWidthImage.vue?vue&type=template&id=6a036e8a"
import script from "./FullWidthImage.vue?vue&type=script&lang=js"
export * from "./FullWidthImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports